const formatImport = (monto, sinSigno) => {
  if (monto === null || monto === undefined) monto = 0;

  const str = monto / 100;

  const format = str.toLocaleString("es-ar", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 2,
  });

  if (sinSigno) return format.substring(2).replace(/\s/g, "-");

  return format;
};

export const formatImportFloat = (monto, sinSigno) => {
  if (monto === null || monto === undefined) return; // Asegura que 0 sea un valor válido

  const format = monto.toLocaleString("es-ar", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 2,
  });

  if (sinSigno) return format.substring(2).replace(/\s/g, "-");

  return format;
};

export const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return "$ 0,00";

  return new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export default formatImport;
